import variablesConstants from "@store/constants/variableTypes";

const INITIAL_STATE = {
  isFetching: false,
  EMAIL_VARIABLES: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case variablesConstants.SET_VARIABLES_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    case variablesConstants.SET_VARIABLES:
      return {
        ...state,
        EMAIL_VARIABLES: action.payload,
      };
    case variablesConstants.RESET_VARIABLES:
      return INITIAL_STATE;
    default:
      return state;
  }
};
